import React from 'react';
import moment from "moment-timezone";
import { /* ProgressBar, */ Row, Col, Button } from "react-bootstrap";
// import { ToggleSwitch } from '../../widgets';
import { DisplayDateRange } from '../../widgets/Date';
import { DISPLAY_DATE_FORMAT2 } from '../../../constants';

export const WorkedAcres = ({ shape, unit, wwInfo, totalArea, timezone, settings, onToggle, fieldReportRequesting }) => {
    const { isRequesting, /* isDisplayAcres, isPresentShape, isTodayAcres,  workedAcres, todayWorkedAcres */} = wwInfo ? wwInfo : {
            isRequesting: false,
            isDisplayAcres: false,
            isPresentShape: false,
            isTodayAcres: false,
            workedAcres: 0,
            todayWorkedAcres: 0
        };

    // const todayWorkedArea = unit.toArea(todayWorkedAcres, 2);
    // const workedArea = unit.toArea(workedAcres, 2);
    // const workedPercent = !isRequesting ? unit.toFixedOf((parseFloat(workedArea) / parseFloat(totalArea)) * 100, 2) : null;

    let duration = "N/A";
    if (isRequesting) duration = "Loading...";
    else if (wwInfo && wwInfo.startDate && wwInfo.endDate)
        duration = <DisplayDateRange
            start={moment.utc(wwInfo.startDate).tz(timezone).format(DISPLAY_DATE_FORMAT2)}
            end={moment.utc(wwInfo.endDate).tz(timezone).format(DISPLAY_DATE_FORMAT2)}
        />;

    return <>
        <Row className="m-0 row-mb align-items-center">
            {/* <Col lg={6} sm={6} md={6} className="p-0"><b>Estimated Worked {settings.areaShortName}</b></Col>
            <Col lg={1} sm={1} md={1} className="p-0">:</Col>
            <Col lg={5} sm={5} md={5} className="p-0">
                {isDisplayAcres && (isRequesting ? "Loading..." :
                    isTodayAcres ? <>{todayWorkedArea} <span className="muted-text">(today)</span></> : workedArea)}
                {wwInfo && !wwInfo.isRequesting && (isDisplayAcres ? isPresentShape : true) &&
                    <ToggleSwitch
                        defaultChecked={wwInfo.isWorkWindow}
                        onChange={onToggle}
                        disabled={!isPresentShape}
                        className={isDisplayAcres ? "float-right" : ""}
                        title={wwInfo.isWorkWindow ? "Work window OFF" : "Work window ON"}
                    />}
            </Col> */}
            {/* <Col lg={5} sm={5} md={5} className="p-0">
                {wwInfo && !wwInfo.isRequesting && (isDisplayAcres ? isPresentShape : true) &&
                    <ToggleSwitch
                        defaultChecked={wwInfo.isWorkWindow}
                        onChange={onToggle}
                        disabled={!isPresentShape}
                        className={isDisplayAcres ? "float-right" : ""}
                        title={wwInfo.isWorkWindow ? "Work window OFF" : "Work window ON"}
                    />}
            </Col> */}
        </Row>
        {!fieldReportRequesting && <Row className="m-0 row-mb">
            <Col lg={12} sm={12} md={12} className="p-0 text-center">{duration}</Col>
        </Row>}
        {/* {workedPercent !== null && <div className="d-flex mt-1">
            <div className="flex-grow-1">
                <ProgressBar>
                    <ProgressBar style={{ backgroundColor: "#ffc107" }} now={workedPercent} key={1} />
                    <ProgressBar style={{ backgroundColor: shape.properties.fillColor }} now={100 - workedPercent} key={2} />
                </ProgressBar>
            </div>
            <div className="ml-2">{`${workedPercent}%`}</div>
        </div>} */}
    </>;
};

export const WorkWindowConfiguration = ({ config, onChangeNumber, onChangeText, onUpdate }) =>
    <div className="shape-info-config">
        <Row className="input-group">
            <Col lg={5} sm={5} md={5} className="p-0 mt-1"><b>Grid Type</b></Col>
            <Col lg={1} sm={1} md={1} className="p-0 mt-1">:</Col>
            <Col lg={6} sm={6} md={6} className="p-0">
                <select
                    value={config.gridType}
                    className="w-100"
                    onChange={e => onChangeText(e.target.value, "gridType")}
                >
                    <option value="square">square</option>
                    <option value="hex">hex</option>
                </select>
            </Col>
        </Row>
        <Row className="input-group">
            <Col lg={5} sm={5} md={5} className="p-0 mt-1"><b>Min cell width</b></Col>
            <Col lg={1} sm={1} md={1} className="p-0 mt-1">:</Col>
            <Col lg={6} sm={6} md={6} className="p-0">
                <input
                    type="number"
                    className="input-control"
                    value={config.minCellWidth}
                    min={0}
                    onChange={e => onChangeNumber(parseInt(e.target.value), "minCellWidth")}
                />
            </Col>
        </Row>
        <Row className="input-group">
            <Col lg={5} sm={5} md={5} className="p-0 mt-1"><b>Field overlap</b></Col>
            <Col lg={1} sm={1} md={1} className="p-0 mt-1">:</Col>
            <Col lg={6} sm={6} md={6} className="p-0">
                <input
                    type="number"
                    className="input-control"
                    value={config.fieldOverlap}
                    min={0}
                    max={100}
                    onChange={e => onChangeNumber(parseInt(e.target.value), "fieldOverlap")}
                />
            </Col>
        </Row>
        <Row className="input-group">
            <Col lg={5} sm={5} md={5} className="p-0 mt-1"><b>Width multipler</b></Col>
            <Col lg={1} sm={1} md={1} className="p-0 mt-1">:</Col>
            <Col lg={6} sm={6} md={6} className="p-0">
                <input
                    type="number"
                    className="input-control"
                    value={config.widthMultipler}
                    min={0}
                    onChange={e => onChangeNumber(parseInt(e.target.value), "widthMultipler")}
                />
            </Col>
        </Row>
        <Row className="input-group">
            <Col lg={5} sm={5} md={5} className="p-0 mt-1"><b>Cell complete</b></Col>
            <Col lg={1} sm={1} md={1} className="p-0 mt-1">:</Col>
            <Col lg={6} sm={6} md={6} className="p-0">
                <input
                    type="number"
                    className="input-control"
                    value={config.cellComplete}
                    min={0}
                    max={100}
                    onChange={e => onChangeNumber(parseInt(e.target.value), "cellComplete")}
                />
            </Col>
        </Row>
        <Row className="m-0 mb-1">
            <Col lg={5} sm={5} md={5} className="p-0 mt-1"><b>Include grid</b></Col>
            <Col lg={1} sm={1} md={1} className="p-0 mt-1">:</Col>
            <Col lg={6} sm={6} md={6} className="p-0 mt-1">
                <input
                    type="checkbox"
                    checked={config.includeGrid}
                    onChange={e => onChangeText(e.target.checked, "includeGrid")}
                />
            </Col>
        </Row>
        <Row className="m-0 mb-1">
            <Col lg={5} sm={5} md={5} className="p-0 mt-1"><b>Include workwindow</b></Col>
            <Col lg={1} sm={1} md={1} className="p-0 mt-1">:</Col>
            <Col lg={6} sm={6} md={6} className="p-0 mt-1">
                <input
                    type="checkbox"
                    checked={config.includeWorkWindow}
                    onChange={e => onChangeText(e.target.checked, "includeWorkWindow")}
                />
            </Col>
        </Row>
        <Row className="m-0">
            <Button variant="primary" size="sm" className="w-100 my-1" onClick={onUpdate}>Update</Button>
        </Row>
    </div>;